import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Banner from '../components/Banner';
import ServicesSection from '../components/ServicesSection';
import IntroSection from '../components/IntroSection';
import IntegrationJourneySection from '../components/IntegrationJourneySection';
import AboutSection from '../components/AboutSection';
import PlanosCtaSection from '../components/PlanosCtaSection';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash?.replace('#', '');
    const target = location.state?.scrollTo || hash;
    if (target) {
      setTimeout(() => {
        document.getElementById(target)?.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    }
  }, [location]);

  return (
    <>
      <Banner />
      <IntroSection />
      <ServicesSection />
      <IntegrationJourneySection />
      <AboutSection />
      <PlanosCtaSection />
      <ContactSection />
    </>
  );
};

export default HomePage;
